import axiosClient from './axiosClient'; // Import the Axios client

export const createBooking = async (bookingData) => {
    try {
        const response = await axiosClient.post('/booking', bookingData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error('Error creating booking:', error.response?.data || error.message);
        throw error; // Rethrow for handling in the calling function
    }
};

export const createBookingRental = async (bookingData) => {
  try {
      const response = await axiosClient.post('/booking/rental', bookingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return API response
  } catch (error) {
      console.error('Error creating booking:', error.response?.data || error.message);
      throw error; // Rethrow for handling in the calling function
  }
};

export const createBookingTour = async (bookingData) => {
  console.log('booo', bookingData);
  try {
      const response = await axiosClient.post('/booking/tour', bookingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return API response
  } catch (error) {
      console.error('Error creating booking:', error.response?.data || error.message);
      throw error; // Rethrow for handling in the calling function
  }
};

export const updateBookingTour = async (id, bookingData) => {
  try {
      const response = await axiosClient.patch(`/booking/tour/${id}`, bookingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return API response
  } catch (error) {
      console.error('Error creating booking:', error.response?.data || error.message);
      throw error; // Rethrow for handling in the calling function
  }
};

export const updateBookingAirport = async (id, bookingData) => {
  try {
      const response = await axiosClient.patch(`/booking/${id}`, bookingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return API response
  } catch (error) {
      console.error('Error creating booking:', error.response?.data || error.message);
      throw error; // Rethrow for handling in the calling function
  }
};


export const updateBookingRental = async (id, bookingData) => {
  try {
      const response = await axiosClient.patch(`/booking/rental/${id}`, bookingData, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return API response
  } catch (error) {
      console.error('Error creating booking:', error.response?.data || error.message);
      throw error; // Rethrow for handling in the calling function
  }
};

export const getBookings = async (filter) => {
    try {
      const response = await axiosClient.get(`/booking?filter=${filter}`); // Token is automatically added
      return response.data;
    } catch (error) {
      console.error('Error fetching bookings:', error.response?.data || error.message);
      throw error;
    }
  };

export const getAccounts = async () => {
  try {
    const response = await axiosClient.get('/booking/accounts'); // Token is automatically added
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error.response?.data || error.message);
    throw error;
  }
};

  export const getBookingsRental = async (filter) => {
    try {
      const response = await axiosClient.get(`/booking/rental?filter=${filter}`); // Token is automatically added
      return response.data;
    } catch (error) {
      console.error('Error fetching bookings:', error.response?.data || error.message);
      throw error;
    }
  };

  export const getBookingsTour = async () => {
    try {
      const response = await axiosClient.get('/booking/tour'); // Token is automatically added
      return response.data;
    } catch (error) {
      console.error('Error fetching bookings:', error.response?.data || error.message);
      throw error;
    }
  };

  export const getDashStats = async () => {
    try {
      const response = await axiosClient.get('/booking/dash'); // Token is automatically added
      return response.data;
    } catch (error) {
      console.error('Error fetching bookings:', error.response?.data || error.message);
      throw error;
    }
  };

  export const getBookingById = async (id) => {
    try {
        const response = await axiosClient.get(`/booking/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching booking:", error);
        throw error;
    }
};

export const getCustomers = async () => {
    try {
      const response = await axiosClient.get('/customers'); // Token is automatically added
      return response.data;
    } catch (error) {
      console.error('Error fetching customers:', error.response?.data || error.message);
      throw error;
    }
  };

  
export const assignVehicleToBooking = async (body) => {
  try {
      const response = await axiosClient.patch(`/booking/assign-vehicle`, {
          vehicleId: body.vehicleId,
          bookingId: body.bookingId
      }, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return the response data
  } catch (error) {
      console.error('Error updating booking:', error);
      throw error; // Rethrow error for handling in the component
  }
};

export const assignVehicleToRentalBooking = async (body) => {
  try {
      const response = await axiosClient.patch(`/booking/assign-vehicle-rental`, {
          vehicleId: body.vehicleId,
          bookingId: body.bookingId
      }, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return the response data
  } catch (error) {
      console.error('Error updating booking:', error);
      throw error; // Rethrow error for handling in the component
  }
};

export const assignVehicleToBookingCheck = async (body) => {
  try {
      const response = await axiosClient.patch(`/booking/assign-vehicle-check`, {
          vehicleId: body.vehicleId,
          bookingId: body.bookingId
      }, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return the response data
  } catch (error) {
      console.error('Error updating booking:', error);
      throw error; // Rethrow error for handling in the component
  }
};

export const assignVehicleToRentalBookingCheck = async (body) => {
  try {
      const response = await axiosClient.patch(`/booking/assign-vehicle-check-rental`, {
          vehicleId: body.vehicleId,
          bookingId: body.bookingId
      }, {
          headers: {
              'Content-Type': 'application/json',
          },
      });
      return response.data; // Return the response data
  } catch (error) {
      console.error('Error updating booking:', error);
      throw error; // Rethrow error for handling in the component
  }
};

export const cancelBookingById = async (id) => {
  try {
    const response = await axiosClient.get(`/booking/cancel/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching booking:", error);
    throw error;
  }
};

export const completeBookingById = async (id) => {
  try {
    const response = await axiosClient.get(`/booking/complete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching booking:", error);
    throw error;
  }
};

export const reassignBookingById = async (id) => {
  try {
    const response = await axiosClient.get(`/booking/reassign/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching booking:", error);
    throw error;
  }
};


export const recoverBookingById = async (id) => {
  try {
    const response = await axiosClient.post(`/booking/status-change`, {
      status: "READY",
      bookingId: id
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching booking:", error);
    throw error;
  }
};

export const noshowBookingById = async (id) => {
  try {
    const response = await axiosClient.post(`/booking/status-change`, {
      status: "NOSHOW",
      bookingId: id
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching booking:", error);
    throw error;
  }
};

// Bulk delete airport bookings - hard delete
export const deleteBookings = async (ids) => {
  try {
    const response = await axiosClient.delete('/booking', {
      data: { ids }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting bookings:", error);
    throw error;
  }
};

// Bulk delete rental bookings - hard delete
export const deleteRentalBookings = async (ids) => {
  try {
    const response = await axiosClient.delete('/booking/rental', {
      data: { ids }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting rental bookings:", error);
    throw error;
  }
};

// Bulk delete tour bookings - hard delete
export const deleteTourBookings = async (ids) => {
  try {
    const response = await axiosClient.delete('/booking/tour', {
      data: { ids }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting tour bookings:", error);
    throw error;
  }
};